import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Route, RouterStateSnapshot, UrlTree } from '@angular/router';
import { ConfigurationSubModule, SecurityRoleTiny, UserType, SecurityModuleUtility, SecurityRoleType, FinanceSecurityRight, QuoteSecurityRight, IndividualComplianceSecurityRight, TimesheetSecurityRight, JobSecurityRight, SchedulerSecurityRight, ConfigurationSecurityRight, CrmSecurityRight, ReportSecurityRight, VariationSecurityRight, AssetSecurityRight, RecurringJobSecurityRight, TaskSecurityRight, JobTemplateSecurityRight, SalesSecurityRight, QuoteTemplateSecurityRight, canViewTasks, canViewCompliance, ProjectsSecurityRight, FormSecurityRight, canViewLegacyRunsheet, EquipmentSecurityRight, LocationSecurityRight } from '@jms/model';
import { Select } from '@jms/shared/ngrx-actions';
import { Observable } from 'rxjs';
import { filter } from 'rxjs/operators';
import { ConfigService } from '@jms/ui/ui.standalone.services/config.service';;
import { UtilService } from '@jms/utils/util.services';
import * as Enumerable from 'linq';

export enum paths {
    Home = 'home',
    Setup = 'setup',
    Customers = 'customers',
    LegacyContacts = 'legacycontacts',
    Contacts = 'contacts',
    Crm = 'crm',
    CrmCustomers = '/crm/customers',
    CrmCustomerShort = 'customers',
    CrmSuppliers = '/crm/suppliers',
    CrmSupplierShort = 'suppliers',
    CrmContractors = '/crm/contractors',
    CrmContractorShort = 'contractors',
    CrmEmployees = '/crm/employees',
    CrmEmployeeShort = 'employees',
    CrmContacts = '/crm/contacts',
    CrmContactShort = 'contacts',
    Technicians = 'technicians',
    ResourceLocation = '/jobs/resource-location',
    ResourceLocationShort = 'resource-location',

    DailyLogs = '/jobs/daily-logs',
    DailyLogsShort = 'daily-logs',

    Operations = '/jobs/operations',
    OperationsShort = 'operations',

    RecurringJobs = '/jobs/recurring',
    RecurringJobsShort = 'recurring',

    HomesNSWNotices = '/jobs/homes-nsw-notices',
    HomesNSWNoticesShort = 'homes-nsw-notices',

    JobTemplates = '/jobs/job-templates',
    JobTemplatesJobsShort = 'job-templates',

    ProjectTemplates = '/jobs/project-templates',
    ProjectTemplatesShort = 'project-templates',

    Projects = '/jobs/projects',
    ProjectsShort = 'projects',

    AdvancedFind = 'find',
    Jobs = 'jobs',
    Pricebooks = 'pricebooks',
    Pricelists = 'pricelists',
    Items = 'items',
    UOM = 'uom',
    Settings = 'settings',
    Users = 'users',
    Companies = 'companies',
    General = 'general',
    Codes = 'codes',
    Categories = 'categories',
    Priorities = 'priorities',
    Jobtypes = 'jobtypes',
    AssetTypes = 'asset/types',
    WorkTypes = 'work/types',
    WorkRoles = 'work/roles',
    MergeTemplates = 'merge/templates',
    Zones = 'zones',

    Quotes = 'quotes',

    QuotesDeprecated = '/quotes/quotes-deprecated',
    QuotesDeprecatedShort = 'quotes-deprecated',

    QuotesNew = '/quotes/quotes-new',
    QuotesNewShort = 'quotes-new',

    QuoteTemplates = '/quotes/quote-templates',

    Sales = 'sales',

    Leads = '/sales/leads',
    LeadsShort = 'leads',

    Opportunities = '/sales/opportunities',
    OpportunitiesShort = 'opportunities',

    QuotesNewUnderSales = '/sales/quotes-new',

    QuoteTemplatesUnderSales = '/sales/quote-templates',
    QuoteTemplatesShort = 'quote-templates',

    Assets = '/assets/assets',
    AssetsOld = '/assets/assets-old',
    Equipment = '/assets/equipment',
    SerialisedEquipment = '/assets/serial-numbers',
    StockLocations = '/assets/stock-locations',

    AssetsShort = 'assets',
    AssetsOldShort = 'assets-old',
    EquipmentShort = 'equipment',
    SerialisedEquipmentShort = 'serial-numbers',
    StockLocationsShort = 'stock-locations',

    Finance = 'finance',
    FinancePendingShort = 'pending',
    FinanceInvoicesShort = 'invoices',
    FinanceBillsShort = 'bills',
    FinancePending = '/finance/pending',
    FinanceInvoices = '/finance/invoices',
    FinanceInvoicesConsolidation = '/finance/invoices-consolidation',
    FinanceInvoicesConsolidationShort = 'invoices-consolidation',
    FinanceBills = '/finance/bills',

    FinancePaymentSync = '/finance/payment-sync',
    FinancePaymentSyncShort = 'payment-sync',

    FinanceReceivable = '/finance/accounts-receivable',
    FinanceReceivableShort = 'accounts-receivable',

    FinancePayable = '/finance/accounts-payable',
    FinancePayableShort = 'accounts-payable',

    FinanceReconcile = '/finance/reconcile-payments',
    FinanceReconcileShort = 'reconcile-payments',

    // Scheduling = 'scheduling',
    // SchedulingRunsheetsShort = 'runsheets',
    // SchedulingAllocationsShort = 'allocations',
    // SchedulingRunsheets = '/scheduling/runsheets',
    // SchedulingAllocations = '/scheduling/allocations',

    Scheduler = 'scheduler',
    Locations = 'locations',

    QuoteStatus = 'quotestatuses',
    IndividualCompliance = 'compliance',
    WorkOrderStatus = 'workorderstatuses',
    SettingsGeneral = '/settings/general',
    SettingsUsers = '/settings/users',
    SettingsRoles = '/settings/roles',
    SettingsCompanies = '/settings/companies',
    SettingsCategories = '/settings/categories',
    SettingsCodes = '/settings/codes',
    SettingsJobtypes = '/settings/jobtypes',
    SettingsAssetTypes = '/settings/asset/types',
    SettingsWorkTypes = '/settings/work/types',
    SettingsWorkRoles = '/settings/work/roles',
    SettingsMergeTemplates = '/settings/merge/templates',
    SettingsPriorities = '/settings/priorities',
    SettingsZones = '/settings/zones',
    SettingsWorkordersStatus = '/settings/workorderstatuses',
    SettingsQuoteStatus = '/settings/quotestatuses',
    SettingsCounters = '/settings/counters',
    SettingsCompliance = '/settings/compliance',
    Compliance = 'compliance',
    SettingsPricebooks = '/settings/pricebooks',
    SettingsPricelists = '/settings/pricelists',
    SettingsItems = '/settings/items',
    SettingsUOM = '/settings/uom',
    Counters = 'counters',
    SettingsTemplates = '/settings/templates',
    Templates = 'templates',
    SettingsDocumentLibrary = '/settings/documentlibrary',
    DocumentLibrary = 'documentlibrary',
    SettingsIndividualComplianceRules = '/settings/compliancerules',
    IndividualComplianceRules = 'compliancerules',
    Sandbox = 'sandbox',
    SettingsLabels = '/settings/labels',
    Labels = 'labels',
    ExportConfig = 'ExportConfig',
    SettingsExportConfig = '/settings/exportconfig',
    SettingsTaxTable = '/settings/taxtable',
    TaxTable = 'taxtable',
    SettingsPublicHoliday = '/settings/publicholiday',
    PublicHoliday = 'publicholiday',
    TimeSheets = 'timesheets',
    Forms = 'forms',
    SettingsForms = '/settings/forms',
    SecurityRoles = 'roles',
    SettingsSecurityRoles = '/settings/roles',
    TenantSecurity = '/settings/tenant-security',
    TenantSecurityShort = 'tenant-security',
    SettingsJobPacks = '/settings/jobpacks',
    JobPacks = 'jobpacks',
    SettingsCustomFields = '/settings/customfields',
    CustomFields = 'customfields',

    SettingsDocumentThemes = '/settings/document-themes',
    DocumentThemes = 'document-themes',

    SettingsEntityForms = '/settings/entity-forms',
    EntityForms = 'entity-forms',

    SettingsApiKeys = '/settings/api-keys',
    ApiKeys = 'api-keys',

    SettingsQuotePolicies = '/settings/quote-policies',
    QuotePolicies = 'quote-policies',

    SettingsJobPolicies = '/settings/job-policies',
    JobPolicies = 'job-policies',

    SettingsJobPoliciesSelector = '/settings/job-policy-selector',
    JobPoliciesSelector = 'job-policy-selector',

    SettingsJobSharingPolicies = '/settings/job-sharing-policies',
    JobSharingPolicies = 'job-sharing-policies',


    // SettingsJobTemplates = '/settings/jobtemplates',
    // JobTemplates = 'jobtemplates',
    SettingsServiceConnections = '/settings/connections',
    ServiceConnections = 'connections',
    SettingsWorkbuddyConnect = '/settings/connect',
    WorkBuddyConnect = 'connect',
    Claim = 'claim',
    SettingsWorkCategories = '/settings/workcategories',
    SettingsTaskChecklists = '/settings/task/checklists',
    TaskChecklists = 'task/checklists',
    Report = 'reports',
    Variations = 'variations',

    SettingsPaymentMethods = '/settings/payment-methods',
    PaymentMethods = 'payment-methods',

    SettingsTaskWorkCompliances = '/settings/task/work-compliance',
    TaskWorkCompliances = 'task/work-compliance',

    SettingsProjectStatus = '/settings/project/status',
    ProjectStatus = 'project/status',

    SettingsEntityStatus = '/settings/entity-status',
    EntityStatus = 'entity-status',

    SettingsTimeSegments = '/settings/time-segments',
    TimeSegments = 'time-segments',


    SettingsOpportunityStages = '/settings/opportunity/stages',
    OpportunityStages = 'opportunity/stages',

    BulkImport = '/settings/bulk/import',
    BulkImportShort = 'bulk/import',

    FinanceSaleOrder = '/finance/sales-order',
    FinanceSaleOrderShort = 'sales-order',

    FinancePurchaseOrder = '/finance/purchase-orders',
    FinancePurchaseOrderShort = 'purchase-orders',
}

@Injectable({ providedIn: 'root' })
export class AuthorizeGuard {

    @Select('application.role')
    private role$: Observable<SecurityRoleTiny>;

    private role: SecurityRoleTiny;
    private configurationSubModules: ConfigurationSubModule[];

    private canViewTasks: boolean;
    private canViewCompliance: boolean;

    // private canViewQuotes: boolean;
    // private canViewOpportunities: boolean;

    private canViewLegacyRunsheet: boolean;

    constructor() {

        this.role$
            .pipe(
                filter(x => x != null)
            )
            .subscribe(x => {
                this.role = x;
                this.configurationSubModules = SecurityModuleUtility.getConfigurationSubAccessModules(x?.rights);
            });

        this.canViewTasks = canViewTasks(ConfigService.environment.taskMode);
        this.canViewCompliance = canViewCompliance(ConfigService.environment.taskMode);

        // this.canViewOpportunities = canViewOpportunities(ConfigService.environment.salesMode);
        // this.canViewQuotes = canViewQuotes(ConfigService.environment.salesMode);

        this.canViewLegacyRunsheet = canViewLegacyRunsheet(ConfigService.environment.runsheetMode);


    }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | UrlTree | Observable<boolean | UrlTree> | Promise<boolean | UrlTree> {
        const canActivate = this.canLoadPath(route.routeConfig.path);

        if (!canActivate) {
            const env = ConfigService.environment;
            localStorage.removeItem('auth_token');
            UtilService.navigate(ConfigService.environment.jms.logoutHref, `https://${env.tenant}.${env.domain}`);
        }

        return canActivate;
    }

    canLoad(route: Route) {
        return this.canLoadPath(route.path);
    }

    public canLoadPath(path: string) {

        if (this.role?.name === SecurityRoleType.SystemAdministrator) {
            return true;
        }

        if (!this.role) return false;

        const { rights } = this.role;

        if (!rights?.length) return false;

        switch (path) {

            case paths.Sandbox:
                return true;

            case paths.Home:
                return this.role?.type === UserType.SubcontractorCompany ? false : true;

            case paths.Setup:
                return false;

            case paths.IndividualCompliance:
                return rights.includes(IndividualComplianceSecurityRight.CanAccess);

            case paths.TimeSheets:
                return rights.includes(TimesheetSecurityRight.CanAccess);

            //TODO: Check if this path is actually used anywhere
            case paths.Contacts:
                return rights.includes(CrmSecurityRight.CanAccess);

            case paths.Crm:
            case paths.CrmCustomers:
            case paths.CrmCustomerShort:
            case paths.CrmSuppliers:
            case paths.CrmSupplierShort:
            case paths.CrmContractors:
            case paths.CrmContractorShort:
            case paths.CrmEmployees:
            case paths.CrmEmployeeShort:
            case paths.CrmContacts:
            case paths.CrmContactShort:
                return rights.includes(CrmSecurityRight.CanAccess);;

            case paths.Variations:
                return rights.includes(VariationSecurityRight.CanAccess);

            case paths.Claim:
                return rights.includes(JobSecurityRight.CanAccess);

            case paths.Quotes:
                // return rights.includes(QuoteSecurityRight.CanAccess);
                return Enumerable
                    .from([
                        QuoteSecurityRight.CanAccess,
                        QuoteTemplateSecurityRight.CanAccess,
                    ])
                    .any(x => this.role.rights.includes(x));

            // case paths.QuotesDeprecated:
            // case paths.QuotesDeprecatedShort:
            //     // return rights.includes(QuoteSecurityRight.CanAccess) && this.canViewQuotes;

            case paths.QuotesNew:
            case paths.QuotesNewUnderSales:
            case paths.QuotesNewShort:
                // return rights.includes(QuoteSecurityRight.CanAccess) && this.canViewOpportunities;
                return rights.includes(QuoteSecurityRight.CanAccess);

            case paths.QuoteTemplates:
            case paths.QuoteTemplatesUnderSales:
            case paths.QuoteTemplatesShort:
                // return rights.includes(QuoteTemplateSecurityRight.CanAccess) && this.canViewOpportunities;
                return rights.includes(QuoteTemplateSecurityRight.CanAccess);

            case paths.Sales:
                return Enumerable
                    .from([
                        SalesSecurityRight.CanAccessOpportunities,
                        SalesSecurityRight.CanAccessLeads,
                    ])
                    // .any(x => this.role.rights.includes(x)) && this.canViewOpportunities;
                    .any(x => this.role.rights.includes(x));

            case paths.Opportunities:
            case paths.OpportunitiesShort:
                // return rights.includes(SalesSecurityRight.CanAccessOpportunities) && this.canViewOpportunities;
                return rights.includes(SalesSecurityRight.CanAccessOpportunities);

            case paths.Leads:
            case paths.LeadsShort:
                // return rights.includes(SalesSecurityRight.CanAccessLeads) && this.canViewOpportunities;
                return rights.includes(SalesSecurityRight.CanAccessLeads);


            case paths.AssetsShort:
                return Enumerable
                    .from([
                        AssetSecurityRight.CanAccess,
                        EquipmentSecurityRight.CanAccess
                    ])
                    .any(x => this.role.rights.includes(x));

            case paths.AssetsOld:
            case paths.AssetsOldShort:
            case paths.Assets:
                return rights.includes(AssetSecurityRight.CanAccess);

            case paths.Equipment:
            case paths.EquipmentShort:
            case paths.SerialisedEquipment:
            case paths.SerialisedEquipmentShort:
            case paths.StockLocations:
            case paths.StockLocationsShort:
                return rights.includes(EquipmentSecurityRight.CanAccess);

            case paths.Jobs:
                return Enumerable
                    .from([
                        JobSecurityRight.CanAccess,
                        RecurringJobSecurityRight.CanAccess,
                        JobTemplateSecurityRight.CanAccess,
                        ProjectsSecurityRight.CanAccessProjects,
                    ])
                    .any(x => this.role.rights.includes(x));


            case paths.Operations:
            case paths.OperationsShort:
                return rights.includes(JobSecurityRight.CanAccess);

            case paths.RecurringJobs:
            case paths.RecurringJobsShort:
                return rights.includes(RecurringJobSecurityRight.CanAccess);

            case paths.HomesNSWNotices:
            case paths.HomesNSWNoticesShort:
                return rights.includes(JobSecurityRight.CanAccess) && ConfigService.environment?.custom?.homesNSW;


            case paths.Projects:
            case paths.ProjectsShort:
            case paths.ProjectTemplates:
            case paths.ProjectTemplatesShort:
                return rights.includes(ProjectsSecurityRight.CanAccessProjects);


            case paths.JobTemplates:
            case paths.JobTemplatesJobsShort: {
                return rights.includes(JobTemplateSecurityRight.CanAccess);
            }

            case paths.ResourceLocation:
            case paths.ResourceLocationShort:
                return rights.includes(SchedulerSecurityRight.CanAccess);

            case paths.DailyLogs:
            case paths.DailyLogsShort:
                return rights.includes(JobSecurityRight.CanAccess);


            // case paths.SchedulingRunsheets:
            // case paths.SchedulingRunsheetsShort:
            //     return this.canViewLegacyRunsheet && rights.includes(SchedulerSecurityRight.CanAccess);

            // case paths.Scheduling:
            // case paths.SchedulingAllocations:
            // case paths.SchedulingAllocationsShort:
            //     return rights.includes(SchedulerSecurityRight.CanAccess);

            case paths.Scheduler:
                return rights.includes(SchedulerSecurityRight.CanAccess);

            case paths.Finance:
                return Enumerable
                    .from([
                        FinanceSecurityRight.CanAccessBills,
                        FinanceSecurityRight.CanAccessInvoices,
                        FinanceSecurityRight.CanAccessPending
                    ])
                    .any(x => this.role.rights.includes(x));


            case paths.FinancePendingShort:
            case paths.FinancePending:
                return this.role.rights.includes(FinanceSecurityRight.CanAccessPending);

            case paths.FinanceInvoicesShort:
            case paths.FinanceInvoices:
            case paths.FinanceInvoicesConsolidationShort:
            case paths.FinanceInvoicesConsolidation:
                return this.role.rights.includes(FinanceSecurityRight.CanAccessInvoices);

            case paths.FinanceBillsShort:
            case paths.FinanceBills:
                return this.role.rights.includes(FinanceSecurityRight.CanAccessBills);

            case paths.FinancePaymentSyncShort:
            case paths.FinancePaymentSync:
                return this.role.rights.includes(FinanceSecurityRight.CanAccessPayments)
                    && this.role.rights.includes(FinanceSecurityRight.ManagePayments);

            case paths.FinancePayableShort:
            case paths.FinancePayable:
            case paths.FinanceReceivableShort:
            case paths.FinanceReceivable:
            case paths.FinanceReconcileShort:
            case paths.FinanceReconcile:
                return this.role.rights.includes(FinanceSecurityRight.CanAccessPayments);

            case paths.FinanceSaleOrder:
            case paths.FinanceSaleOrderShort:
                return this.role.rights.includes(FinanceSecurityRight.CanAccessSaleOrder);

            case paths.FinancePurchaseOrder:
            case paths.FinancePurchaseOrderShort:
                return rights.includes(FinanceSecurityRight.CanAccessPurchaseOrder);

            case paths.Report:
                return rights.includes(ReportSecurityRight.CanAccess);


            case paths.Settings:
                return Enumerable.from([
                    ConfigurationSecurityRight.AccessMetadata,
                    ConfigurationSecurityRight.AccessPricing,
                    ConfigurationSecurityRight.AccessTemplates,
                    ConfigurationSecurityRight.AccessTenancy,
                    ConfigurationSecurityRight.AccessCustomFields,
                    // ConfigurationSecurityRight.AccessJobTemplates,
                ]).any(x => this.role.rights.includes(x));


            // Pricing
            case paths.Codes:
            case paths.SettingsCodes:
            case paths.Categories:
            case paths.SettingsCategories:
            case paths.SettingsPricebooks:
            case paths.Pricebooks:
            case paths.SettingsPricelists:
            case paths.Pricelists:
            case paths.Items:
            case paths.SettingsItems:
            case paths.UOM:
            case paths.SettingsUOM:
                return this.configurationSubModules.includes(ConfigurationSubModule.Pricing);

            case paths.SettingsIndividualComplianceRules:
            case paths.IndividualComplianceRules:
                return this.configurationSubModules.includes(ConfigurationSubModule.IndividualCompliance);

            // case paths.Users:
            // case paths.SettingsUsers:
            //     return this.configurationSubModules.includes(ConfigurationSubModule.User);

            case paths.SecurityRoles:
            case paths.SettingsSecurityRoles:
            case paths.TenantSecurity:
            case paths.TenantSecurityShort:
                return this.configurationSubModules.includes(ConfigurationSubModule.Security);

            // Metadata
            case paths.SettingsLabels:
            case paths.Labels:
            case paths.Priorities:
            case paths.SettingsPriorities:
            case paths.Jobtypes:
            case paths.SettingsJobtypes:
            case paths.AssetTypes:
            case paths.SettingsAssetTypes:
            case paths.WorkOrderStatus:
            case paths.SettingsWorkordersStatus:
            case paths.QuoteStatus:
            case paths.SettingsQuoteStatus:
            case paths.Zones:
            case paths.SettingsZones:
            case paths.SettingsWorkCategories:
            case paths.WorkTypes:
            case paths.SettingsWorkTypes:
            case paths.WorkRoles:
            case paths.SettingsWorkRoles:
            case paths.OpportunityStages:
            case paths.SettingsOpportunityStages:
            case paths.ProjectStatus:
            case paths.SettingsProjectStatus:
            case paths.EntityStatus:
            case paths.SettingsEntityStatus:
            case paths.SettingsTimeSegments:
            case paths.TimeSegments:
                return this.configurationSubModules.includes(ConfigurationSubModule.Metadata);

            case paths.SettingsCustomFields:
            case paths.CustomFields:
                return this.configurationSubModules.includes(ConfigurationSubModule.Metadata)
                    && rights.includes(ConfigurationSecurityRight.AccessCustomFields);

            // case paths.BulkImport:
            // case paths.BulkImportShort:
            //     return rights.includes(ConfigurationSecurityRight.AccessBulkImport);

            // Templates
            case paths.SettingsTemplates:
            case paths.Templates:
            case paths.MergeTemplates:
            case paths.SettingsMergeTemplates:
            case paths.SettingsDocumentLibrary:
            case paths.DocumentLibrary:
            case paths.SettingsJobPacks:
            case paths.JobPacks:
                // case paths.SettingsDocumentThemes:
                // case paths.DocumentThemes:
                return this.configurationSubModules.includes(ConfigurationSubModule.Templates);

            case paths.SettingsDocumentThemes:
            case paths.DocumentThemes:
                return this.configurationSubModules.includes(ConfigurationSubModule.Templates) && rights.includes(ConfigurationSecurityRight.AccessDocumentThemes);

            case paths.SettingsEntityForms:
            case paths.EntityForms:
                return rights.includes(ConfigurationSecurityRight.AccessEntityForms);

            case paths.BulkImport:
            case paths.BulkImportShort:
                return this.configurationSubModules.includes(ConfigurationSubModule.Metadata) && rights.includes(ConfigurationSecurityRight.AccessBulkImport);

            case paths.General:
            case paths.SettingsGeneral:
            case paths.Companies:
            case paths.SettingsCompanies:
            // case paths.Counters:
            // case paths.SettingsCounters:
            case paths.ExportConfig:
            case paths.SettingsExportConfig:
            case paths.SettingsTaxTable:
            case paths.TaxTable:
            case paths.SettingsPublicHoliday:
            case paths.PublicHoliday:
            case paths.ServiceConnections:
            case paths.SettingsServiceConnections:
            case paths.ApiKeys:
            case paths.SettingsApiKeys:
            case paths.PaymentMethods:
            case paths.SettingsPaymentMethods:
            case paths.QuotePolicies:
            case paths.SettingsQuotePolicies:
            case paths.SettingsJobPolicies:
            case paths.JobPolicies:
            case paths.SettingsJobPoliciesSelector:
            case paths.JobPoliciesSelector:
            case paths.SettingsJobSharingPolicies:
            case paths.JobSharingPolicies:
                return this.configurationSubModules.includes(ConfigurationSubModule.Tenancy);


            // Compliance
            case paths.SettingsCompliance:
            case paths.Compliance:
                return this.configurationSubModules.includes(ConfigurationSubModule.WorkCompliance) && this.canViewCompliance;

            // Location
            case paths.Locations:
                return rights.includes(LocationSecurityRight.CanAccess);


            case paths.SettingsTaskWorkCompliances:
            case paths.TaskWorkCompliances:
                return this.configurationSubModules.includes(ConfigurationSubModule.WorkCompliance) && this.canViewTasks;

            case paths.SettingsTaskChecklists:
            case paths.TaskChecklists:
                return rights.includes(TaskSecurityRight.CanAccess) && this.canViewTasks;

            case paths.Forms:
            case paths.SettingsForms:
                return rights.includes(FormSecurityRight.CanAccessForms);

            default:
                return false;
        }
    }
}
